function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { getCombinedStringifiedEditorState } from 'rubriq/helpers/richTextWordCount';
import Link from 'shared/components/Link';
import { T, useTranslate } from 'shared/helper/translate';
import RubriqLoadingSpinner from '../../components/RubriqLoadingSpinner';
import { loadCriteriaWizardSession } from '../../actions';
import RubriqAbstractToolbar from './RubriqAbstractToolbar';
import RubriqGlobalWordCount from './RubriqGlobalWordCount';
import RichTextDisplay from './editor/RichTextDisplay';
var RubriqReview = function RubriqReview() {
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useParams = useParams(),
    sessionIdentity = _useParams.sessionIdentity;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState('preview'),
    _useState4 = _slicedToArray(_useState3, 2),
    switcherState = _useState4[0],
    setSwitcherState = _useState4[1];
  var dispatch = useDispatch();
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    templateResponses = _useSelector.curie.abstractWriter.templateResponses;
  useEffect(function () {
    dispatch(loadCriteriaWizardSession(sessionIdentity)).then(function () {
      setLoading(false);
    });
  }, []);
  if (loading) {
    return /*#__PURE__*/React.createElement(RubriqLoadingSpinner, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-4"
  }, /*#__PURE__*/React.createElement(RubriqAbstractToolbar, null), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center pb-2 border-bottom"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "fs-5 fw-semibold m-0"
  }, /*#__PURE__*/React.createElement(T, {
    source: "review"
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-2 align-items-center"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/rubriq/abstract-writer/".concat(sessionIdentity, "/template"),
    className: "btn btn-primary rubriq-ghost-button d-flex gap-1 align-items-center fw-semibold"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-list"
  }), /*#__PURE__*/React.createElement(T, {
    source: "curie.template"
  })), /*#__PURE__*/React.createElement("button", {
    "aria-label": t('copy'),
    type: "button",
    className: "copy-text btn btn-primary"
  }, /*#__PURE__*/React.createElement(T, {
    source: "copy"
  })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column pe-4 pb-3 gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-2"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "m-0 fw-semibold fs-3"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.review-title"
  })), /*#__PURE__*/React.createElement("p", {
    className: "m-0 p-0 text-secondary"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.review-helper"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "btn-group",
    role: "group",
    "aria-label": "Combine switcher"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn ".concat(switcherState === 'preview' ? 'active' : '', " border rounded-start d-flex gap-1 flex-grow-0 align-items-center rubriq-abstract-combine-btn text-capitalize"),
    onClick: function onClick() {
      return setSwitcherState('preview');
    }
  }, switcherState === 'preview' && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-check"
  }), /*#__PURE__*/React.createElement(T, {
    source: "curie.preview"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn ".concat(switcherState === 'revise' ? 'active' : '', " border rounded-end d-flex gap-1 flex-grow-0 align-items-center rubriq-abstract-combine-btn text-capitalize"),
    onClick: function onClick() {
      return setSwitcherState('revise');
    }
  }, switcherState === 'revise' && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-check"
  }), /*#__PURE__*/React.createElement(T, {
    source: "curie.revise"
  }))), switcherState === 'preview' && /*#__PURE__*/React.createElement(RichTextDisplay, {
    editorState: getCombinedStringifiedEditorState(Object.values(templateResponses))
  })), /*#__PURE__*/React.createElement(RubriqGlobalWordCount, null))));
};
export default RubriqReview;